import * as yup from 'yup';

export interface ProcedureCodeFormValues {
  insurerId: number | null;
  cptCode: string;
  paymentTypeId: number | null;
  partnershipId: number | null;
  clientId: number | null;
  modifier1: string;
  modifier2: string;
}

export interface ValidatedProcedureCodeFormValues
  extends ProcedureCodeFormValues {
  paymentTypeId: number;
}

export const DEFAULT_PROCEDURE_CODE_FORM_VALUES: ProcedureCodeFormValues = {
  insurerId: null,
  cptCode: '',
  paymentTypeId: null,
  partnershipId: null,
  clientId: null,
  modifier1: '',
  modifier2: '',
};

const INVALID_ENTITY_COMBINATION_MSG =
  'Valid combinations: partnership only, client only, insurer only, partnership and insurer, or client and insurer';

const isValidEntityCombination: yup.TestFunction<number | null | undefined> =
  function () {
    const { partnershipId, insurerId, clientId } = this.parent;

    const hasPartnership = partnershipId != null;
    const hasInsurer = insurerId != null;
    const hasClient = clientId != null;

    if (hasPartnership && !hasClient && !hasInsurer) return true;
    if (hasClient && !hasPartnership && !hasInsurer) return true;
    if (hasInsurer && !hasPartnership && !hasClient) return true;
    if (hasPartnership && hasInsurer && !hasClient) return true;
    if (hasClient && hasInsurer && !hasPartnership) return true;

    return false;
  };

export const ProcedureCodeValidationSchema = yup.object({
  partnershipId: yup
    .number()
    .nullable()
    .defined()
    .test(
      'valid-entity-combination',
      INVALID_ENTITY_COMBINATION_MSG,
      isValidEntityCombination,
    ),
  insurerId: yup
    .number()
    .nullable()
    .defined()
    .test(
      'valid-entity-combination',
      INVALID_ENTITY_COMBINATION_MSG,
      isValidEntityCombination,
    ),
  clientId: yup
    .number()
    .nullable()
    .defined()
    .test(
      'valid-entity-combination',
      INVALID_ENTITY_COMBINATION_MSG,
      isValidEntityCombination,
    ),
  cptCode: yup.string().trim().required('CPT code is required'),
  paymentTypeId: yup.number().nullable().required('Payment type is required'),
  modifier1: yup.string().defined(),
  modifier2: yup.string().defined(),
}) as yup.ObjectSchema<ProcedureCodeFormValues>;
